import { PermissionActions } from '@/features/permissions/permissionActions.js'
import SuperAdminDummyRouter from '@/features/superAdmin/SuperAdminDummyRouter.vue'

export const membershipCategoryManagementRoutes = [
  {
    path: 'membership-category-management',
    component: SuperAdminDummyRouter,
    meta: { permissionAction: PermissionActions.MembershipCategoriesView },
    children: [
      {
        path: '',
        component: () =>
          import('@/features/settingsManagement/membershipCategoryManagement/list/MembershipCategoryListView.vue'),
        meta: { permissionAction: PermissionActions.MembershipCategoriesView },
      },
      {
        path: ':membershipCategoryId',
        component: () =>
          import('@/features/settingsManagement/membershipCategoryManagement/edit/MembershipCategoryEditView.vue'),
        meta: { permissionAction: PermissionActions.MembershipCategoriesView },
      },
      {
        path: 'new',
        component: () =>
          import('@/features/settingsManagement/membershipCategoryManagement/edit/MembershipCategoryEditView.vue'),
        meta: { permissionAction: PermissionActions.MembershipCategoriesCreate },
      },
    ],
  },
]
